import { IconFont } from '@/components/IconFont'
import { projectContext } from '@/layouts/MainLayout'
import { updateDirectoryOrFile } from '@/services/file/file'
import { Button, Form, Input, Space } from 'antd'
import { memo, useContext, useEffect, useState } from 'react'
import styles from './index.module.less'

export default memo(function DirectoryName(props: any) {
  const { dir, onEditSuccess, onClick } = props
  const { projectId, projectType } = useContext(projectContext)
  const [form] = Form.useForm()
  const [editing, setEditing] = useState(false)

  const save = async (values) => {
    await updateDirectoryOrFile(values, { projectId, projectType, id: dir.id })
    onEditSuccess()
    setEditing(false)
  }

  useEffect(() => {
    form.setFieldsValue(dir)
  }, [dir])

  if (editing) {
    return (
      <Form form={form} layout='inline' onFinish={save}>
        <Form.Item name='name'>
          <Input />
        </Form.Item>

        <Button type={'primary'} className={'mr-2'} htmlType={'submit'}>
          Save
        </Button>

        <Button
          type={'default'}
          htmlType={'button'}
          onClick={() => {
            setEditing(false)
          }}
        >
          Cancel
        </Button>
      </Form>
    )
  }

  return (
    <Space className={styles.container}>
      <a onClick={onClick}>{dir.name}</a>
      <IconFont type='icon-edit' onClick={() => setEditing(true)} />
    </Space>
  )
})
